import { Container } from 'fitify-ui-landing/src/components/Container/Container'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import { css, styled } from 'styled-components'

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 48px;

  ${phone(css`
    gap: 32px;
  `)};
`
